var _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHashpack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 10,
    fill: "url(#paint0_linear_2490_13006)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 7.55556C15 9.76469 13.2091 11.5556 11 11.5556C8.79086 11.5556 7 9.76469 7 7.55556C7 6.69645 7.69645 6 8.55556 6C9.41466 6 10.1111 6.69645 10.1111 7.55556V10.5378C10.6876 10.7094 11.3124 10.7094 11.8889 10.5378V7.55556C11.8889 6.69645 12.5853 6 13.4444 6C14.3036 6 15 6.69645 15 7.55556ZM8.55556 6.88889C8.92374 6.88889 9.22222 7.18737 9.22222 7.55556V10.109C8.41623 9.54683 7.88889 8.61278 7.88889 7.55556C7.88889 7.18737 8.18737 6.88889 8.55556 6.88889ZM12.7778 7.55556V10.109C13.5838 9.54683 14.1111 8.61278 14.1111 7.55556C14.1111 7.18737 13.8126 6.88889 13.4444 6.88889C13.0763 6.88889 12.7778 7.18737 12.7778 7.55556Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7778 14.2222V12.1112C11.6447 12.5537 10.3544 12.5534 9.22222 12.1112V14.2222C9.22222 14.5904 8.92374 14.8889 8.55556 14.8889C8.18737 14.8889 7.88889 14.5904 7.88889 14.2222V11.327C7.55162 11.0484 7.25234 10.7255 7 10.3672V14.2222C7 15.0813 7.69645 15.7778 8.55556 15.7778C9.41466 15.7778 10.1111 15.0813 10.1111 14.2222V13.2654C10.6989 13.3561 11.3011 13.3561 11.8889 13.2654V14.2222C11.8889 15.0813 12.5853 15.7778 13.4444 15.7778C14.3036 15.7778 15 15.0813 15 14.2222V10.3672C14.7477 10.7255 14.4484 11.0484 14.1111 11.327V14.2222C14.1111 14.5904 13.8126 14.8889 13.4444 14.8889C13.0763 14.8889 12.7778 14.5904 12.7778 14.2222Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2490_13006",
    x1: 7.48649,
    y1: 3.7027,
    x2: 21.5,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B3A49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A1925"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashpack);
export default __webpack_public_path__ + "static/media/hashpack.ee18d2164ce7afd01b41614363cddf50.svg";
export { ForwardRef as ReactComponent };